import { tokenManager } from './tokenManager';

class TokenRefreshManager {
  constructor() {
    this.isRefreshing = false;
    this.refreshPromise = null;
    this.init();
  }

  init() {
    console.log('🚀 TokenRefreshManager initialized (reactive refresh on 401 errors only)');
  }

  async refreshTokenSilently() {
    if (this.isRefreshing) {
      console.log('⏳ Refresh already in progress, waiting for completion...');
      return this.refreshPromise;
    }

    console.log('🔄 Starting token refresh...');
    this.isRefreshing = true;
    this.refreshPromise = this.performRefresh();

    try {
      const result = await this.refreshPromise;
      console.log('✅ Token refresh completed successfully');
      return result;
    } catch (error) {
      console.error('❌ Token refresh failed:', error);
      // If refresh fails, redirect to login
      console.log('🚪 Redirecting to login due to refresh failure...');
      tokenManager.clearTokens();
      window.location.href = '/';
      throw error;
    } finally {
      this.isRefreshing = false;
      this.refreshPromise = null;
    }
  }

  async performRefresh() {
    const user = tokenManager.getUser();
    if (!user || !user.id || !user.role) {
      throw new Error('No user data available for refresh');
    }

    console.log(`🔑 Refreshing token for user: ${user.email} (${user.role})`);

    // Create a proper refresh token payload
    const refreshTokenPayload = {
      userId: user.id,
      role: user.role,
      timestamp: Date.now()
    };

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL || 'https://backend.adhdrapidcare.com/api'}/users/refresh-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        refresh_token: btoa(JSON.stringify(refreshTokenPayload))
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Token refresh failed');
    }

    const data = await response.json();
    const { access_token } = data;
    
    // Update stored access token
    tokenManager.setTokens(access_token);
    console.log('💾 New access token stored successfully');
    
    return data;
  }
}

// Create and export a singleton instance
export const tokenRefreshManager = new TokenRefreshManager(); 